// src/components/Dashboard/Navbar.js
import {
  ArrowRightOnRectangleIcon,
  Bars3Icon,
  XMarkIcon,
} from "@heroicons/react/20/solid";
import { signOut } from "firebase/auth";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../../firebase";
import Wordmark from "./Wordmark";

export default function Navbar() {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  async function handleLogout() {
    await signOut(auth);
    navigate("/login");
  }

  const menuItems = [
    { label: "Account", onClick: () => navigate("/account"), variant: "button" },
  ];

  return (
    <nav
      id="dashboard-nav"
      className="sticky top-0 z-30 border-b border-slate-200/80 bg-white/95 shadow-[0_1px_0_rgba(15,23,42,0.04)] backdrop-blur-xl"
    >
      <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between px-4 sm:px-6 lg:px-8">
        <button
          type="button"
          onClick={() => navigate("/dashboard")}
          className="flex items-center rounded-lg px-2 py-1.5 hover:bg-slate-50"
          aria-label="Go to dashboard"
        >
          <Wordmark className="text-xl" />
        </button>

        <div className="hidden items-center gap-2 md:flex">
          {menuItems.map((item) =>
            item.variant === "button" ? (
              <button
                key={item.label}
                type="button"
                className="ghost-button"
                onClick={item.onClick}
              >
                {item.label}
              </button>
            ) : (
              <a
                key={item.label}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="ghost-button"
              >
                {item.label}
              </a>
            )
          )}
          <button
            onClick={handleLogout}
            className="secondary-button ml-2 gap-2"
            aria-label="Log out"
            type="button"
          >
            <ArrowRightOnRectangleIcon className="h-4 w-4" />
            Log out
          </button>
        </div>

        <button
          onClick={() => setIsMobileMenuOpen((open) => !open)}
          className="secondary-button px-3 md:hidden"
          aria-label="Toggle menu"
          type="button"
        >
          {isMobileMenuOpen ? (
            <XMarkIcon className="h-5 w-5" />
          ) : (
            <Bars3Icon className="h-5 w-5" />
          )}
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className="border-t border-slate-200 bg-white px-4 py-3 shadow-lg md:hidden">
          <div className="mx-auto grid max-w-[1400px] gap-2">
            <button
              className="ghost-button justify-start"
              type="button"
              onClick={() => {
                setIsMobileMenuOpen(false);
                navigate("/account");
              }}
            >
              Account
            </button>
            <button
              onClick={() => {
                setIsMobileMenuOpen(false);
                handleLogout();
              }}
              className="ghost-button justify-start text-rose-600 hover:text-rose-700"
              aria-label="Log out"
              type="button"
            >
              Log out
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
